import {
    spaceRegular,
    spaceLarge,
    spaceWide,
} from '@ui/styles/spaces';
import {
    lightMarineColor,
    pureWhite,
} from '@ui/styles/colors';

export const sliderContentStyle = {
    justifyContent : 'center',
    alignItems     : 'center',
    boxSizing      : 'border-box' as 'border-box',
    width          : '100%',
};

export const sliderAssetStyle = {
    alignItems      : 'center' as 'center',
    objectFit       : 'cover' as 'cover',
    layout          : 'fill',
    height          : '40vh',
    width           : '100%',
    backgroundColor : 'black',
};

export const sliderAssetBigStyle = {
    ...sliderAssetStyle,
    height: '60vh',
};

export const sliderAssetStyleFullHeight = {
    ...sliderAssetStyle,
    height: 'calc(var(--vh, 1vh) * 100)',
};

export const sliderBodyItemsWrapperStyle = {
    justifyContent : 'center',
    alignItems     : 'center',
    marginTop      : spaceRegular,
    marginBottom   : spaceRegular,
};

export const sliderTitleStyle = {
    textAlign    : 'center' as 'center',
    marginTop    : spaceWide,
    marginBottom : spaceRegular,
};

export const sliderBodyStyle = {
    textAlign : 'center' as 'center',
    margin    : spaceLarge,
};

const iconStyle = {
    '& .MuiSvgIcon-root': {
        borderRadius : '50%',
        transform    : 'scale(1.22)',
    },

    '& .MuiIconButton-label': {
        backgroundColor : pureWhite,
        borderRadius    : '50%',
    },
};

export const nextButtonStyle = {
    ...iconStyle,
    color    : lightMarineColor,
    width    : 'auto',
    height   : 'auto',
    position : 'absolute' as 'absolute',

    '&:after': {
        display : 'none',
        content : 'none',
    },
};

export const previousButtonStyle = {
    ...nextButtonStyle,
    transform: 'rotate(180deg)',
};
